export const getMeetingIdFromUrl = (meetingUrl) => {
  if (!meetingUrl) return ""
  if (meetingUrl.lastIndexOf('?') === -1) {
    return meetingUrl.slice(meetingUrl.lastIndexOf("/") + 1);
  } else {
    return meetingUrl.slice(meetingUrl.lastIndexOf("/") + 1, meetingUrl.lastIndexOf("?"));
  }
}

export const getMeetingPasswordFromUrl = (meetingUrl) => {
  if (!meetingUrl) return ""
  let meetingId = meetingUrl.slice(meetingUrl.lastIndexOf("pwd=") + 4);
  return meetingId;
}

export const parseLink = (value) => {
  if (value.lastIndexOf('?') === -1) {
    return value
  } else {
    return value.slice(0, value.lastIndexOf("?"))
  }
}     